import {
  get,
  post,
  put,
  destroy
} from 'app/services/ApiService';

import {
  SEARCH_ACCOUNTS_URL,
  ACCOUNT_LOGO_UPLOAD_URL,
  ACCOUNTS_URL,
  FEATURE_FLAGS_URL,
  ACCOUNT_WATERMARK_URL,
  ACCOUNT_WATERMARK_UPLOAD_URL,
  ACCEPT_INVITE_URL,
  WHEEL_ACCOUNT_USERS,
  WHEEL_GET_ACCOUNT_USER,
  WHEEL_BECOME_ACCOUNT_USER,
  WHEEL_CHANGE_PASSWORD_URL
} from 'app/utils/Constants';

import {
  ACCOUNT_URL,
  ACCOUNT_PIN_UPDATE_URL
} from 'shared/utils/Constants'

import {
  TEXT,
  EQUALS
} from 'app/hooks/useFilter';

export const getAccount = async id => {
  let params = {
    page: 1,
    per_page: 1,
    filter_model: {
      id: [{
        filterClass: TEXT,
        filterType: EQUALS,
        value: id.toString()
      }]
    },
    sort_model: []
  }

  let resp = await getAccounts(params);
  return resp.records[0];
}

export const getAccounts = async params => {
  return await post(SEARCH_ACCOUNTS_URL(), params);
}

export const createAccount = async params => {
  return await post(ACCOUNTS_URL(), params);
}

export const updateAccount = async (id, params) => {
  return await put(ACCOUNT_URL(id), params);
}

export const destroyAccount = async id => {
  return await destroy(ACCOUNT_URL(id));
}

export const getAccountLogoSignedUrl = async (accountId, contentType) => {
  return await get(ACCOUNT_LOGO_UPLOAD_URL(accountId, contentType));
}

export const updateAccountPin = async (accountId, params) => {
  return await put(ACCOUNT_PIN_UPDATE_URL(accountId), params);
}

export const updateFeatureFlags = async (params) => {
  return await put(FEATURE_FLAGS_URL(), params);
}

export const getAccountWatermark = async (accountId) => {
  return await get(ACCOUNT_WATERMARK_URL(accountId));
}

export const getAccountWatermarkSignedUrl = async (accountId, contentType) => {
  return await get(ACCOUNT_WATERMARK_UPLOAD_URL(accountId, contentType));
}

export const getAccountUsers = async (accountId) => {
  return await get(WHEEL_ACCOUNT_USERS(accountId));
}

export const getAccountUser = async (email, userId) => {
  return await get(WHEEL_GET_ACCOUNT_USER(email, userId));
}

export const becomeAccountUser = async (email, userId) => {
  return await get(WHEEL_BECOME_ACCOUNT_USER(email, userId));
}

export const acceptInviteLogin = async params => {
  return await post(ACCEPT_INVITE_URL(), params);
}

export const userChangePassword = async (password, userId) => {
  return await get(WHEEL_CHANGE_PASSWORD_URL(password, userId));
}